/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface RequestRestoreAmazonItemRequest
 */
export interface RequestRestoreAmazonItemRequest {
    /**
     *
     * @type {number}
     * @memberof RequestRestoreAmazonItemRequest
     */
    id: number;
    /**
     *
     * @type {number}
     * @memberof RequestRestoreAmazonItemRequest
     */
    status: number;
    /**
     *
     * @type {number}
     * @memberof RequestRestoreAmazonItemRequest
     */
    userId: number;
    /**
     *
     * @type {number}
     * @memberof RequestRestoreAmazonItemRequest
     */
    tenantId: number;
}

/**
 * Check if a given object implements the RequestRestoreAmazonItemRequest interface.
 */
export function instanceOfRequestRestoreAmazonItemRequest(value: object): value is RequestRestoreAmazonItemRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    return true;
}

export function RequestRestoreAmazonItemRequestFromJSON(json: any): RequestRestoreAmazonItemRequest {
    return RequestRestoreAmazonItemRequestFromJSONTyped(json, false);
}

export function RequestRestoreAmazonItemRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestRestoreAmazonItemRequest {
    if (json == null) {
        return json;
    }
    return {

        'id': json['id'],
        'status': json['status'],
        'userId': json['userId'],
        'tenantId': json['tenantId'],
    };
}

export function RequestRestoreAmazonItemRequestToJSON(json: any): RequestRestoreAmazonItemRequest {
    return RequestRestoreAmazonItemRequestToJSONTyped(json, false);
}

export function RequestRestoreAmazonItemRequestToJSONTyped(value?: RequestRestoreAmazonItemRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'id': value['id'],
        'status': value['status'],
        'userId': value['userId'],
        'tenantId': value['tenantId'],
    };
}
